import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NgbPagination} from './pagination';
import {NgbPaginationConfig} from './pagination-config';

export {NgbPagination} from './pagination';
export {NgbPaginationConfig} from './pagination-config';


export class NgbPaginationModule {
  static forRoot(): ModuleWithProviders { return {ngModule: NgbPaginationModule, providers: [NgbPaginationConfig]}; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{declarations: [NgbPagination], exports: [NgbPagination], imports: [CommonModule]}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
